const styles = {
  textAlign: 'center',
  alignSelf: 'center'
};

export function ComparePhotoResultColumns({ t }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      filterable: false,
      width: 80,
      style: styles
    },
    {
      Header: t('comparePhoto_columnFirstContingentId'),
      accessor: 'firstContingentId',
      maxWidth: 250,
      filterable: false,
      style: styles
    },
    {
      Header: t('comparePhoto_columnFirstContingentGroupName'),
      accessor: 'firstContingentGroupName',
      filterable: false,
      style: styles
    },
    {
      Header: t('comparePhoto_columnSecondContingentId'),
      accessor: 'secondContingentId',
      filterable: false,
      maxWidth: 250,
      style: styles
    },
    {
      Header: t('comparePhoto_columnSecondContingentGroupName'),
      accessor: 'secondContingentGroupName',
      filterable: false,
      style: styles
    },
    {
      Header: t('comparePhoto_columnSimilarityPercentage'),
      accessor: 'similarityPercentage',
      filterable: false,
      maxWidth: 180,
      style: styles,
      Cell: ({ original }) =>
        original?.similarityPercentage != null
          ? `${original.similarityPercentage}%`
          : ''
    }
  ];
}
